import React from 'react';
import {ScrollView, StyleSheet, View} from 'react-native';
import {observer} from 'mobx-react';

import Button from '../../components/themed/Button';
import ContentView from '../../components/ui-controls/layout/ContentView';
import Markdown from '../../components/ui-controls/Markdown';
import Text from '../../components/ui-controls/Text';
import {Title} from '../../components/ui-controls/text/Title';
import config from '../../config';
import {AppRoute} from '../../models/AppRoute';
import {useStores} from '../../stores/use-stores';
import theme from '../../style/theme';
import {navigateToLiquorShop} from '../../utils/giftCards';
import {GIFT_CARD_DELIVERY_TIME} from '../constants';
import {GiftCardShopRouteNavigatorScreenProps} from '../types/navigationTypes';

const copy = `
Thank you for choosing a gift card from ${config.APP_NAME}  Whether you're surprising a loved one, celebrating a milestone, or simply spreading some joy, we hope the gift brings joy and smiles to all who receive it.

Your Gift Card will be delivered to the recipient by email on the selected delivery date (emails are sent from ${GIFT_CARD_DELIVERY_TIME} on the selected date). If you chose today's date, the Gift Card will be sent immediately.

If you have any questions or need assistance with anything related to your gift card, please don't hesitate to reach out to our customer support team at [${config.SUPPORT_EMAIL}](mailto:${config.SUPPORT_EMAIL}).
`;

type GiftCardStoreOrderConfirmationScreenProps =
  GiftCardShopRouteNavigatorScreenProps<AppRoute.GIFT_CARDS_STORE_ORDER_CONFIRMATION>;

const GiftCardStoreOrderConfirmationScreen = observer(
  ({navigation}: GiftCardStoreOrderConfirmationScreenProps) => {
    const rootStore = useStores();
    const {cartStore} = rootStore;

    const handleBuyAnotherGiftCard = () => {
      cartStore.reset();
      navigation.navigate(AppRoute.GIFT_CARDS_HOME, {isResetForm: true});
    };

    const handleReturnToYourStore = () => {
      cartStore.reset();
      navigateToLiquorShop(navigation, rootStore);
    };

    const orderNumber = cartStore.currentOrder?.order_number;

    return (
      <ContentView testID="gift-card-order-confirmation-screen">
        <ScrollView>
          <Title>Thanks for your order!</Title>
          <Text>
            {'\n'}
            <Text style={{fontWeight: 'bold'}}>Order Number: </Text>
            <Text testID="gift-card-order-confirmation-order-number">{orderNumber}</Text>
          </Text>
          <Markdown>{copy}</Markdown>
          <View style={styles.buttonGroup}>
            <Button
              buttonStyle={styles.button}
              onPress={handleBuyAnotherGiftCard}
              title="BUY ANOTHER GIFT CARD"
            />
            <Button
              buttonStyle={styles.button}
              onPress={handleReturnToYourStore}
              title="RETURN TO YOUR STORE"
            />
          </View>
        </ScrollView>
      </ContentView>
    );
  },
);

export default GiftCardStoreOrderConfirmationScreen;

const styles = StyleSheet.create({
  buttonGroup: {
    marginTop: 24,
    marginBottom: 24,
    alignItems: 'center',
    gap: 12,
  },
  button: {
    width: 250,
    height: 52,
    backgroundColor: theme.colour.background.button.primary,
  },
});
